import React from "react";
import Select, { components } from "react-select";

function MonthSelector({
  months = [],
  selectedMonth,
  onChange,
  placeholder = "Select Month",
  isDisabled = false,
}) {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: "38px",
      borderColor: state.isFocused ? "#1F4D2C" : "#d1d5db",
      borderRadius: "8px",
      boxShadow: state.isFocused ? "0 0 0 3px rgba(31, 77, 44, 0.1)" : "none",
      "&:hover": {
        borderColor: state.isFocused ? "#1F4D2C" : "#9ca3af",
      },
      backgroundColor: state.isDisabled ? "#f9fafb" : "#ffffff",
      cursor: state.isDisabled ? "not-allowed" : "pointer",
      transition: "all 0.2s ease",
      fontFamily: "Inter, sans-serif",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "2px 12px",
      fontFamily: "Inter, sans-serif",
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
      fontFamily: "Inter, sans-serif",
      fontSize: "0.9rem",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#9ca3af",
      fontSize: "0.9rem",
      fontFamily: "Inter, sans-serif",
    }),
    singleValue: (base, state) => ({
      ...base,
      color: state.isDisabled ? "#9ca3af" : "#374151",
      fontSize: "0.9rem",
      fontFamily: "Inter, sans-serif",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (base, state) => ({
      ...base,
      color: state.isDisabled ? "#d1d5db" : "#6b7280",
      padding: "8px",
      transition: "all 0.2s ease",
      "&:hover": {
        color: state.isDisabled ? "#d1d5db" : "#1F4D2C",
      },
    }),
    menu: (base) => ({
      ...base,
      borderRadius: "8px",
      boxShadow:
        "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
      border: "1px solid #e5e7eb",
      marginTop: "4px",
      overflow: "hidden",
      fontFamily: "Inter, sans-serif",
      zIndex: 9999,
    }),
    menuList: (base) => ({
      ...base,
      padding: "4px",
      fontFamily: "Inter, sans-serif",
      maxHeight: "300px",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#1F4D2C"
        : state.isFocused
          ? "#f0fdf4"
          : "#ffffff",
      color: state.isSelected ? "#ffffff" : "#374151",
      padding: "10px 12px",
      cursor: "pointer",
      borderRadius: "6px",
      fontSize: "0.9rem",
      fontFamily: "Inter, sans-serif",
      transition: "all 0.15s ease",
      "&:active": {
        backgroundColor: state.isSelected ? "#1F4D2C" : "#dcfce7",
      },
    }),
    noOptionsMessage: (base) => ({
      ...base,
      color: "#9ca3af",
      fontSize: "0.9rem",
      padding: "12px",
      fontFamily: "Inter, sans-serif",
    }),
  };

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <i className="bi bi-calendar-month" style={{ fontSize: "1rem" }}></i>
      </components.DropdownIndicator>
    );
  };

  // Transform months to react-select format
  const options = months.map((month) => ({
    value: JSON.stringify(month.createdAt),
    label: month.name,
  }));

  // Find the selected option
  const selectedOption = options.find((opt) => opt.value === selectedMonth) || null;

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <label
        style={{
          display: "block",
          fontSize: "0.875rem",
          fontWeight: 500,
          color: "#374151",
          marginBottom: "6px",
          fontFamily: "Inter, sans-serif",
        }}
      >
        Month
      </label>
      <Select
        options={options}
        onChange={onChange}
        value={selectedOption}
        placeholder={placeholder}
        isDisabled={isDisabled}
        isSearchable={false}
        styles={customStyles}
        components={{ DropdownIndicator }}
        noOptionsMessage={() => "No months available"}
      />
    </div>
  );
}

export default MonthSelector;
